import { render } from "./SidenavList.vue?vue&type=template&id=ee66d888"
import script from "./SidenavList.vue?vue&type=script&lang=js"
export * from "./SidenavList.vue?vue&type=script&lang=js"

import "./SidenavList.vue?vue&type=style&index=0&id=ee66d888&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__